import { create } from "zustand";
import { cloudStorage } from "../telegram";

/**
 * п.27 ТЗ: "не скидати вибір клієнта без необхідності" — вибір авто й параметри кредиту
 * зберігаються між переходами по екранах (і навіть між сесіями — через Telegram CloudStorage).
 */
export interface SelectedCar {
  modelSlug: string;
  modelName: string;
  trimId: string;
  trimName: string;
  colorOptionId: string;
  colorCode: string;
  priceUAH: number;
  powertrainType: string;
}

export interface CreditSelection {
  programId: string;
  termMonths: number;
  advancePercent: number;
}

interface AppState {
  selectedCar: SelectedCar | null;
  creditSelection: CreditSelection | null;
  hydrated: boolean;
  setSelectedCar: (car: SelectedCar | null) => void;
  setCreditSelection: (sel: CreditSelection | null) => void;
  hydrate: () => Promise<void>;
}

const STORAGE_KEY = "karat_state_v1";

export const useAppStore = create<AppState>((set, get) => ({
  selectedCar: null,
  creditSelection: null,
  hydrated: false,

  setSelectedCar: (car) => {
    set({ selectedCar: car });
    persist(get());
  },
  setCreditSelection: (sel) => {
    set({ creditSelection: sel });
    persist(get());
  },
  hydrate: async () => {
    try {
      const raw = await cloudStorage.get(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw) as Partial<AppState>;
        set({ selectedCar: parsed.selectedCar ?? null, creditSelection: parsed.creditSelection ?? null });
      }
    } catch {
      /* якщо збережений стан пошкоджений — просто стартуємо з чистого */
    } finally {
      set({ hydrated: true });
    }
  },
}));

function persist(state: AppState): void {
  cloudStorage.set(
    STORAGE_KEY,
    JSON.stringify({ selectedCar: state.selectedCar, creditSelection: state.creditSelection })
  );
}
